import { render, staticRenderFns } from "./fireResistantStructSpecDoc.vue?vue&type=template&id=1db14972"
import script from "./fireResistantStructSpecDoc.vue?vue&type=script&lang=js"
export * from "./fireResistantStructSpecDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1db14972')) {
      api.createRecord('1db14972', component.options)
    } else {
      api.reload('1db14972', component.options)
    }
    module.hot.accept("./fireResistantStructSpecDoc.vue?vue&type=template&id=1db14972", function () {
      api.rerender('1db14972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/frss/fireResistantStructSpecDoc.vue"
export default component.exports